import dayjs from 'dayjs';
import * as fmt from './format';

/** Prefill for a planned brew created from a recommendation. */
const brewFromRecommendation = (rec) => ({
  beerName: rec.beerName,
  brewery: rec.brewery,
  volumeLitres: rec.tankLitres,
  brewDate: rec.brewDate,
  packageDate: rec.arrivalDate,
  status: 'planned',
  packSplit: (rec.packSplit || [])
    .filter((p) => !p.viaMix)
    .map(({ sku, units }) => ({ sku, units })),
  notes: `From forecast recommendation (${fmt.date(dayjs().format('YYYY-MM-DD'))})`,
});

export default brewFromRecommendation;
